import { TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";

export class BuildingRankUpTextComponentsTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.Bebasneuepro_Smerg,
            fontSize: 40,
            align: 'center',
            fill: '#FFFFFF'
        });
    }
}